import React from 'react';
import $image_url from 'js/utils/image_url';
import routes from 'js/core_pre_webpack/routes';
import OnsitePing, { Props as OnsitePingProps } from './onsite_ping';
import styled from 'astroturf/react';
import { keptAlivePost } from 'js/utils/kept_alive_post';
import Modal from 'js/components/modals/Modal';

const AnchorContainer = styled.div`
  padding: 0;
  white-space: nowrap;
  display: flex;
  justify-content: center;

  @media screen and (min-width: 950px) {
    padding: 10px 20px;
  }
`;

const Anchor = styled.a`
  width: 100%;
  border-radius: 4px !important;
  padding: 12px 32px;

  background: #0849b8;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);

  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;

  &:hover,
  &:active {
    text-decoration: none;
    color: #ffffff;
  }
`;

const Takeover = styled.div`
  @media screen and (min-width: 950px) {
    padding: 0 100px;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 100%;
  justify-content: space-evenly;
  max-width: calc(100vw - 32px * 2 - 20px);

  font-family: roboto;
  text-align: center;

  h1 {
    font-weight: 300;
    font-size: 16px;
    line-height: 22.4px;
    margin: 0;

    @media screen and (min-width: 950px) {
      font-size: 32px;
      line-height: 41.6px;
      margin: 10px 0;
    }
  }

  p {
    margin: 12px 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 18.2px;
    width: 605px;
    max-width: calc(100% - 20px);

    @media screen and (min-width: 950px) {
      font-size: 22px;
      line-height: 26.4px;
    }
  }
`;

const TakeoverImage = styled.img`
  width: 120px;
  max-width: 100%;

  @media screen and (min-width: 950px) {
    width: 218px;
  }
`;

const CtaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  font-size: 16px;
  line-height: 22px;
`;

const NoThanksButton = styled.button`
  margin: 10px 12px;
  padding: 0;
  background: none;
  border: none;
  color: #0849b8;
  font-weight: 500;
`;

interface Props extends OnsitePingProps {
  couponCode: string;
}

type State = {
  open: boolean;
};

export default class WinBackPing extends OnsitePing<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  render() {
    if (this.state.open) {
      return this.renderTakeoverPing();
    } else {
      return null;
    }
  }

  renderTakeoverPing() {
    return (
      <Modal onClose={() => this.dismissPing()}>
        <Takeover>
          <TakeoverImage
            src={$image_url('page_50_percent.svg')}
            alt="50% off Academia Premium"
          />
          <h1>Reactivate Your Membership & Get 50% Off</h1>
          <p>{this.getBody()}</p>
          <CtaRow>
            {this.renderButton()}
            <NoThanksButton onClick={() => this.dismissPing()}>
              No Thanks
            </NoThanksButton>
          </CtaRow>
        </Takeover>
      </Modal>
    );
  }

  getBody() {
    return 'Reactivate now and get the tools you need to accelerate your research and advance your career.';
  }

  renderButton() {
    return (
      <AnchorContainer>
        <Anchor
          href={this.getUpgradeURL()}
          onClick={() => this.recordClickthrough()}
        >
          {this.getButtonText()}
        </Anchor>
      </AnchorContainer>
    );
  }

  recordClickthrough(): void {
    const url = routes.record_ping_clickthrough_api_v0_onsite_pings_path({
      subdomain_param: 'api',
    });
    keptAlivePost(url, {
      processData: false,
      data: { ping_name: this.props.pingName },
    });
  }

  dismissPing(): void {
    this.setState({ open: false });
    this.recordDismissal();
  }

  recordDismissal(): void {
    const url = routes.record_ping_dismissal_api_v0_onsite_pings_path({
      subdomain_param: 'api',
    });
    keptAlivePost(url, {
      processData: false,
      data: { ping_name: this.props.pingName },
    });
  }

  getUpgradeURL() {
    return routes.checkout_url({
      trigger: 'win-back-ping',
      premium_discount_coupon: this.props.couponCode,
    });
  }

  getButtonText() {
    return 'Reactivate and Get 50% Off ▸';
  }
}
